// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { GLTFLoader } from 'https://unpkg.com/three@0.160.0/examples/jsm/loaders/GLTFLoader.js'
import { LoadingManager } from 'three'
import { DRACOLoader } from 'https://unpkg.com/three@0.160.0/examples/jsm/loaders/DRACOLoader.js'

// const manager = new LoadingManager();
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath(
  'https://www.gstatic.com/draco/versioned/decoders/1.5.6/'
)
dracoLoader.setDecoderConfig({ type: 'js' })


export default class ModelLoader {
  constructor(application) {
    this.application = application
    this.loader = null
  }

  async initGLTFLoader() {
    const loadingManager = new LoadingManager(
      (e) => { },

      // progress
      (item, loaded, total) => {
        if (!this.application) return
        const progress = loaded / total
        this.application.eventEmitter.notify('loadedProgress', progress)
      }
    )
    // await dracoLoader.preload()
    this.loader = new GLTFLoader(loadingManager)
    this.loader.setDRACOLoader(dracoLoader)
  }

  async loadModel(url) {
    try {
      const obj = await this.loader.loadAsync(url)
      if (this.application) {
        this.application.eventEmitter.notify('setLoadingFinished')
      }
      return obj
    } catch (e) {
      console.error(e.message)
    }
  }
}
